export function openArticleDetail(article) {
  if (!article || !article.sid) {
    return;
  }
  const url = `${window.location.origin}/articleDetail?sid=${encodeURIComponent(article.sid)}`;
  window.open(url, "_blank");
}
